<template v-if="record">
  <div
    class="inventory-item-actions"
    :class="{
      'inventory-item-actions-yellow': record.status.desc === 'notissued',
      'inventory-item-actions-red': record.status.desc === 'issuedoverdue',
    }"
  >
    <c-button
      v-if="record.isShowIssuedMoreButton"
      class="inventory-item-actions-give-more"
      size="small"
      label="Выдать еще"
      @click="isShowNewInventoryItemModal = true"
    />
    <c-button
      v-if="record.status.desc === 'notissued'"
      class="inventory-item-actions-give"
      size="small"
      label="Выдать"
      @click="isShowNewInventoryItemModal = true"
    />
    <c-button
      v-if="
        record.status.desc === 'issued' || record.status.desc === 'issuedoverdue' || record.status.desc === 'hasalready'
      "
      v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Удалить', placement: 'top' }"
      class="inventory-item-actions-trash"
      :class="{
        'inventory-item-actions-trash-margin':
          record.status.desc === 'issuedoverdue' || record.status.desc === 'hasalready',
      }"
      size="iconic"
      icon="trash"
      @click="removeInventoryItem()"
    />

    <b-modal
      id="inventory-items-actions-new-item-modal"
      v-model="isShowNewInventoryItemModal"
      centered
      hide-footer
      hide-header
      @show="onShowModal"
    >
      <div class="inventory-items-actions-modal">
        <svg
          class="inventory-item-actions-modal-close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="isShowNewInventoryItemModal = false"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        <div class="inventory-item-actions-modal-title">
          {{ record.position.value }}
        </div>
        <div
          class="inventory-item-actions-modal-inputs"
          :class="{ 'inventory-item-actions-modal-inputs-required': dateIssuingLocalErrorMessage.length > 0 }"
        >
          <c-input
            ref="inventoryActionsDateNewIssue"
            v-model="dateIssuingLocal"
            class="inventory-item-actions-modal-inputs-date"
            label="Дата выдачи"
            type="date"
            format="DD.MM.YYYY, dddd"
            :editable="true"
            icon="calendar"
            placeholder="00.00.0000"
            :required="dateIssuingLocalErrorMessage"
            :icon-right="true"
            @invalidDate="sendErrorDateMessage"
          />
          <c-input
            v-model="whoIssuedLocal"
            class="inventory-item-actions-modal-inputs-select"
            :items="whoIssuingItems"
            type="select"
            :required="whoIssuedLocalErrorMessage"
            :required-condition="whoIssuedLocalErrorMessage.length > 0"
            :searchable="true"
            label="Кто выдал"
            placeholder="Выберите значение"
          />
        </div>
        <div class="inventory-item-actions-modal-buttons">
          <c-button
            class="inventory-item-actions-modal-buttons-cancel"
            label="Отменить"
            @click="isShowNewInventoryItemModal = false"
          />
          <c-button
            class="inventory-item-actions-modal-buttons-save"
            label="Сохранить"
            color="primary"
            @click="issueInventory"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";

export default {
  name: "c-table-actions",

  components: {
    "c-button": Button,
    "c-input": Input,
  },

  props: ["record"],

  data() {
    return {
      isShowNewInventoryItemModal: false,
      dateIssuingLocal: "",
      dateIssuingLocalErrorMessage: "",
      whoIssuingItems: [],
      whoIssuedLocal: null,
      whoIssuedLocalErrorMessage: "",
      submitAttempt: false,
    };
  },

  watch: {
    dateIssuingLocal(value) {
      if (this.submitAttempt) {
        if (value.length === 0) {
          this.dateIssuingLocalErrorMessage = "Обязательное поле";
        } else if (value.length < 10) {
          this.dateIssuingLocalErrorMessage = "Укажите корректное значение";
        } else {
          this.dateIssuingLocalErrorMessage = "";
        }
      }
    },
  },

  mounted() {
    // this.dateIssuingLocal = moment().format('DD.MM.YYYY')
    // this.$refs.dateInput.setCurrentDateInputTypeDate()
  },

  methods: {
    sendErrorDateMessage(e) {
      if (e)
        this.dateIssuingLocalErrorMessage = "Укажите корректное значение";
    },
    closeModal() {
      this.isShowNewInventoryItemModal = false;
    },
    onShowModal() {
      this.$nextTick(() => {
        this.$refs.inventoryActionsDateNewIssue.setCurrentDateInputTypeDate();
      });

      this.workersLocal = [];

      const currentUserId = this.$store.state.userId;

      this.$store.dispatch("personalEmployee/getWorkersList", currentUserId).then((res) => {
        res.response.forEach((item) => {
          this.whoIssuingItems.push({ value: item.id, label: item.name, isUser: item.is_user });
        });

        const c = this.whoIssuingItems.findIndex((worker) => worker.value.toString() === currentUserId.toString());

        if (c !== -1) {
          this.whoIssuedLocal = this.whoIssuingItems[c];
        }
      });
    },
    issueInventory() {
      let isValidForm = true;

      if (this.dateIssuingLocal.length === 0) {
        this.dateIssuingLocalErrorMessage = "Обязательное поле";
        isValidForm = false;
        this.submitAttempt = true;
      }

      if (this.dateIssuingLocal.length < 10) {
        this.dateIssuingLocalErrorMessage = "Укажите корректное значение";
        isValidForm = false;
        this.submitAttempt = true;
      }

      if (isValidForm && this.dateIssuingLocalErrorMessage.length === 0) {
        const params = {
          workerId: this.$route.params.id,
          uniformId: this.record.id.value,
          postCode: this.record.postCode,
          dateIssue: this.dateIssuingLocal,
          isUserIssued: this.whoIssuedLocal.isUser,
          authorId: this.whoIssuedLocal.value,
          userId: this.whoIssuedLocal.value,
        };

        this.$store.dispatch("personalEmployee/issueInventoryItemToEmployee", params).then(() => {
          let inventoryItemsComponent;
          if (this.record.postsCount > 1) {
            inventoryItemsComponent = this.$parent.$parent.$parent.$parent;
          } else {
            inventoryItemsComponent = this.$parent.$parent.$parent;
          }

          inventoryItemsComponent._data.isDataLoading = true;
          inventoryItemsComponent.getInventoryItemsTableData();
          inventoryItemsComponent.getHistoryInventoryItemsTableData();
          setTimeout(() => {
            inventoryItemsComponent._data.isDataLoading = false;
            setTimeout(() => {
              inventoryItemsComponent.setPeriodInventoryItemsHistory();
            }, 300);
          }, 500);
        });

        this.closeModal();
      }
    },
    removeInventoryItem() {
      this.$store.dispatch("personalEmployee/cancelIssueInventoryItemToEmployee", this.record.elementId).then(() => {
        let inventoryItemsComponent;
        if (this.record.postsCount > 1) {
          inventoryItemsComponent = this.$parent.$parent.$parent.$parent;
        } else {
          inventoryItemsComponent = this.$parent.$parent.$parent;
        }

        inventoryItemsComponent._data.isDataLoading = true;
        inventoryItemsComponent.getInventoryItemsTableData();
        inventoryItemsComponent.getHistoryInventoryItemsTableData();
        setTimeout(() => {
          inventoryItemsComponent._data.isDataLoading = false;
          setTimeout(() => {
            inventoryItemsComponent.setPeriodInventoryItemsHistory();
          }, 300);
        }, 500);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.inventory-item-actions {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 164px;
  padding: 5px 10px;

  @media screen and (max-width: 700px) {
    justify-content: flex-start;
    padding: 6px 10px;
  }

  &-give {
    background: #ffffff;
    padding: 0 20px;
  }

  &-give-more {
    background: #ffffff;
    padding: 0 20px;

    @media screen and (max-width: 700px) {
      margin-left: auto;
      order: 2;
    }
  }

  &-trash {
    margin-left: auto;

    @media screen and (max-width: 700px) {
      margin-left: initial;
    }

    &-margin {
      margin-left: auto;

      @media screen and (max-width: 700px) {
        order: 1;
        margin: 0;
      }
    }
  }

  &-modal {
    position: relative;

    &-close {
      cursor: pointer;
      position: absolute;
      top: 13px;
      right: 12px;
    }

    &-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 120%;

      @media screen and (max-width: 700px) {
        font-size: 15px;
      }
    }

    &-inputs {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;

      &-date {
        width: 110px;

        @media screen and (max-width: 700px) {
          width: calc(50% - 10px);
        }

        & ::v-deep .c-input-icon {
          margin-top: -3px;
        }

        & ::v-deep .c-input-required-text {
          white-space: normal;
        }

        & ::v-deep .c-input-required_active {
          bottom: -30px;
        }

        @media screen and (max-width: 700px) {
          & ::v-deep .c-input-required_active {
            bottom: -22px;
          }
        }

        @media screen and (max-width: 416px) {
          & ::v-deep .c-input-required_active {
            bottom: -28px;
          }
        }
      }

      &-select {
        width: 384px;

        @media screen and (max-width: 700px) {
          margin-top: 52px;
          width: 100%;
        }
      }

      @media screen and (max-width: 700px) {
        margin-top: 26px;
        padding-bottom: 48px;
        flex-direction: column;
      }

      &-required {
        margin-bottom: 40px;
      }
    }

    &-buttons {
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      @media screen and (max-width: 700px) {
        position: absolute;
        bottom: 0;
        margin-left: -20px;
        width: 100%;
        max-width: 100%;
      }

      &-cancel {
        @media screen and (max-width: 700px) {
          width: 50%;
          border-left: none;
          border-bottom: none;
          border-radius: 0;
        }
      }

      &-save {
        margin-left: 10px;
        @media screen and (max-width: 700px) {
          margin-left: 0;
          width: 50%;
          border-radius: 0;
        }
      }
    }
  }

  &-red {
    background: #ffe6f2;

    @media screen and (max-width: 700px) {
      background: #ffffff;
    }
  }

  &-yellow {
    background: #fdffb3;

    @media screen and (max-width: 700px) {
      background: #ffffff;
    }
  }
}
</style>
